"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOrgSecurity = exports.ISsoSupportedOrg = exports.IOrganization = void 0;
const openapi_1 = require("../../../openapi");
const app_product_1 = require("./app-product");
class IOrganization {
    key;
    displayName;
    extensivId;
    salesForceCustomerId;
    isInternalTestOrg;
    ownerUserEmail;
    isSuperOrg;
    isC2;
    isEssential;
    logo;
    loginContent;
    phoneNumber;
    productAccess;
    productsID;
    productIDs;
    security;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrganization.prototype, "key", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrganization.prototype, "displayName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'System assigned on create',
    })
], IOrganization.prototype, "extensivId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrganization.prototype, "salesForceCustomerId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrganization.prototype, "isInternalTestOrg", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'email' })
], IOrganization.prototype, "ownerUserEmail", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrganization.prototype, "isSuperOrg", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrganization.prototype, "isC2", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrganization.prototype, "isEssential", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri' })
], IOrganization.prototype, "logo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uri' })
], IOrganization.prototype, "loginContent", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrganization.prototype, "phoneNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => app_product_1.IProductAccess)
], IOrganization.prototype, "productAccess", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => app_product_1.IProductsID)
], IOrganization.prototype, "productsID", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => app_product_1.IProductIDs)
], IOrganization.prototype, "productIDs", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IOrgSecurity)
], IOrganization.prototype, "security", void 0);
exports.IOrganization = IOrganization;
class ISsoSupportedOrg {
    domain;
    orgKey;
    clientKey;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ISsoSupportedOrg.prototype, "domain", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], ISsoSupportedOrg.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], ISsoSupportedOrg.prototype, "clientKey", void 0);
exports.ISsoSupportedOrg = ISsoSupportedOrg;
class IOrgSecurity {
    mfaEnabled;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrgSecurity.prototype, "mfaEnabled", void 0);
exports.IOrgSecurity = IOrgSecurity;
